export default __webpack_public_path__ + "static/media/Team3.b2fbf178.jpg";